import { map } from 'rxjs';

import { HttpEvent, HttpResponse, HttpInterceptorFn } from '@angular/common/http';

import { ApiEnvelope } from '@/app/shared/http/types';

import { BYPASS_UNWRAP } from '@/app/core/http';
import { unwrapApiEnvelope } from '@/app/shared/http';

export const unwrapApiEnvelopeInterceptor: HttpInterceptorFn = (request, next) => {
  const isJson = (request.responseType ?? 'json') === 'json';
  const shouldBypass = request.context.get(BYPASS_UNWRAP) || !isJson;

  const isI18nRequest = request.url.includes('i18n');
  if (isI18nRequest) {
    return next(request);
  }

  return next(request).pipe(
    map((event: HttpEvent<unknown>) => {
      if (shouldBypass || !(event instanceof HttpResponse)) {
        return event;
      }

      const body = event.body as ApiEnvelope<unknown>;
      const unwrappedBody = unwrapApiEnvelope(body);

      return event.clone({ body: unwrappedBody });
    }),
  );
};
